



















































































































































import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onUnmounted,
  getCurrentInstance,
  computed,
} from '@vue/composition-api';
import dayjs from 'dayjs';

import CollaborationCard from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/CollaborationCard.vue';
import BrowserCreateCollaboration from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/BrowserCreateCollaboration.vue';
import MobileCreateCollaboration from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/MobileCreateCollaboration.vue';
import InviteMembers from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/InviteMembers.vue';
import RenameGroup from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/RenameGroup.vue';
import SelectAnySpaceTargetFolder from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/index.vue';
import RefreshableHeader from '@/renderer/components/SpacePage/components/RefreshableHeader.vue';
import FunctionBox from '@/renderer/components/SpacePage/components/FunctionBox.vue';

import coSpaceListHandler from '@/renderer/views/desktop/FileManagement/CollaborationSpace/compositions/coSpaceListHandler';
import dynamicOpenHandler from '@/renderer/components/drawer/Dynamic/composition/dynamicOpenHandler';
import smh, { SMH } from '@/renderer/scripts/smh';
import { loopAsyncTask } from '@/renderer/scripts/utils/syncTask';
import ipc from '@/renderer/scripts/utils/ipc';
import tips from '@/renderer/scripts/utils/tips';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';
import i18n, { i18n_t } from '@/locales/i18n';
import CollaborationNewFunctionGuide from './components/CollaborationNewFunctionGuide.vue';

export default defineComponent({
  name: 'CoSpace',
  components: {
    CollaborationCard,
    BrowserCreateCollaboration,
    MobileCreateCollaboration,
    InviteMembers,
    RenameGroup,
    SelectAnySpaceTargetFolder,
    RefreshableHeader,
    CollaborationNewFunctionGuide,
    FunctionBox,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;

    const showCreateCollaborationGuide = ref(false);
    const showInviteMemberGuide = ref(false);
    const joinTimeOptions = [
      {
        label: i18n_t('全部'),
        value: 'all',
      },
      {
        label: i18n_t('今天'),
        value: '0',
      },
      {
        label: i18n_t('最近7天'),
        value: '7',
      },
      {
        label: i18n_t('最近15天'),
        value: '15',
      },
      {
        label: i18n_t('最近30天'),
        value: '30',
      },
      {
        label: i18n_t('超过30天'),
        value: '30+',
      },
    ];

    const typeOptions = [
      {
        label: i18n_t('全部'),
        value: 'all',
      },
      {
        label: i18n_t('我发起的'),
        value: 'own',
      },
      {
        label: i18n_t('我收到的'),
        value: 'join',
      },
    ];

    const modificationTime = ref('');
    const modificationTimeOptions = [
      {
        label: i18n_t('修改时间'),
        value: 'modificationTime',
      },
      {
        label: i18n_t('字母顺序'),
        value: 'alphabetic',
      },
    ];

    const store = context.root.$store;
    const importPath = ref('');
    const justShowImportPath = computed(() => importPath.value?.split('/')?.pop() || '');
    const isTemporary = computed(() => vm.$store.getters.userBaseInfo.isTemporary);
    let importSpaceId = '';
    const showDialog = reactive<Record<string, boolean>>({
      create: false,
      invite: false,
      rename: false,
      import: false,
    });
    const manual = ref(false);
    const keepSelected = ref({});
    // 是否正在导入loading中
    const importLoading = ref(false);
    const {
      tableData,
      pageData,
      selected,
      loading,
      loadingOnHeader,
      methods: listMethods,
      conditionParams,
    } = coSpaceListHandler();
    const disableOperate = computed(
      () => selected.value?.orgId !== store.getters.orgId || selected.value?.ownerId !== store.getters.userId,
    );

    const distSpaceId = ref('');
    dynamicOpenHandler(ref(selected.value?.spaceId));

    const methods = {
      toggleDialog(type: string, val: boolean) {
        showDialog[type] = val;
        if (type === 'create' && !val) importPath.value = '';
        if (type === 'invite' && val) manual.value = true;
      },
      async refresh(params?: any) {
        await listMethods.pullList(params);
      },
      silentRefresh() {
        if (!loading.value && !loadingOnHeader.value) {
          listMethods.pullList(undefined, true);
        }
      },
      async onCreateSuccess(groupId: number, type?: 'invite' | string) {
        // 重置筛选条件，避免新增的数据不在筛选条件内
        conditionParams.joinType = 'all';
        conditionParams.joinTime = 'all';
        conditionParams.joinTimeParams = {};
        // 避免因分页获取不到对应item，无法添加成员或导入文件夹
        if (pageData.currPage === 1) {
          await methods.refresh({
            currPage: 1,
          });
        } else {
          await listMethods.onCurrentChange(1);
        }
        const item = tableData.list.find(item => item.id === groupId);
        if (item) {
          try {
            keepSelected.value = item; // selected 刷新后消失，此处保留
            if (importPath.value) {
              distSpaceId.value = item?.spaceId as string;
              await methods.save(importSpaceId, importPath.value);
            }
            methods.toggleDialog('create', false);
            // 自动打开邀请弹窗
            manual.value = false;
            showDialog.invite = true;
          } catch (error) {
            //
          }
        }
        reporter.report('group', {
          group_count: tableData.list.length,
        });
      },
      // 极可能是点击 也可能是取消
      selectCoSpace(
        data: SMH.ColleborationSpaceInfoData & {
          checked: boolean;
        },
      ) {
        if (data.checked) {
          data.checked = !data.checked;
          store.commit('set_cospace_selected', true);
        } else {
          if (selected.value) selected.value.checked = false;
          data.checked = true;
          keepSelected.value = data; // 选中群组，添加成员后刷新列表，数据保存避免邀请框所需group为空
          store.commit('set_cospace_selected', false);
        }
      },
      savePathInfo(params: { spaceId: string; dirPath: string }) {
        importPath.value = params.dirPath;
        importSpaceId = params.spaceId;
        methods.toggleDialog('import', false);
      },
      async save(spaceId: string, dirPath: string) {
        const distDirPath = dirPath.split('/').pop();
        const source = spaceId ? 'space_company' : 'space_personal';
        try {
          const fromSpaceId = spaceId || (await spaceATM.getPersonalSpaceIdAsync());
          const params = {
            copyFrom: dirPath,
            copyFromSpaceId: fromSpaceId,
            dirPath: distDirPath || '',
            spaceId: distSpaceId.value,
          };
          tips.loading(i18n_t('导入中'), 0);
          importLoading.value = true;
          const res = await smh.commonAPI.crossSpaceCopyDirectory(params);
          methods.toggleDialog('import', false);
          if (res.status === 200) {
            await methods.refresh();
            reporter.report('group', { group_import_success: 1, group_import_source: source });
            tips.success(i18n_t('导入成功'));
            importLoading.value = false;
          } else if (res.status === 202) {
            const { taskId } = res.data;
            const asyncRes = await loopAsyncTask(smh.commonAPI.asyncTaskQuery, taskId as number, distSpaceId.value);
            if (asyncRes.status === 200) {
              await methods.refresh();
              reporter.report('group', { group_import_success: 1, group_import_source: source });
              tips.success(i18n_t('导入成功'));
              importLoading.value = false;
            } else if (asyncRes.status === 400) {
              await methods.refresh();
              tips.error(i18n_t('导入失败：空间不足，请清理个人空间或联系管理员扩容！'));
              importLoading.value = false;
            }
          }
        } catch (error) {
          importLoading.value = false;
          reporter.report('group', { group_import_success: 0, group_import_source: source });
          tips.error(error as MsgError);
        }
      },
      conditionChange() {
        switch (conditionParams.joinTime) {
          case 'all':
            conditionParams.joinTimeParams = {};
            break;
          case '0':
            conditionParams.joinTimeParams = {
              joinTimeStart: dayjs().format('YYYY-MM-DD'),
            };
            break;
          case '7':
          case '15':
          case '30':
            conditionParams.joinTimeParams = {
              joinTimeStart: dayjs().subtract(Number(conditionParams.joinTime), 'days').format('YYYY-MM-DD'),
            };
            break;
          case '30+':
            conditionParams.joinTimeParams = {
              joinTimeEnd: dayjs().subtract(30, 'days').format('YYYY-MM-DD'),
            };
            break;
          default:
            break;
        }

        methods.refresh();
      },
    };

    methods.refresh();

    const guideTipsShow = (val: string) => {
      if (val === 'showCreateCollaborationGuide') {
        showCreateCollaborationGuide.value = true;
        setTimeout(() => {
          showCreateCollaborationGuide.value = false;
        }, 3000);
      } else if (val === 'showInviteMemberGuide') {
        // 自动选择第一个属于自己创建的群组
        for (let i = 0; i < tableData.list.length; i++) {
          if (tableData.list[i].ownerId === store.getters.userId) {
            tableData.list[i].checked = true;
            break;
          }
        }
        showInviteMemberGuide.value = true;
        setTimeout(() => {
          showInviteMemberGuide.value = false;
        }, 3000);
      }
    };

    const refreshMember = () => {
      methods.refresh();
    };

    ipc.on(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, guideTipsShow);
    ipc.on(ipc.RENDERER_EVENTS_MAP.DRAWER_MANAGER_MEMBER, refreshMember);

    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.GUIDE_SHOW_GUIDE_TIPS, guideTipsShow);
      ipc.off(ipc.RENDERER_EVENTS_MAP.DRAWER_MANAGER_MEMBER, refreshMember);
    });

    return {
      joinTimeOptions,
      typeOptions,
      modificationTime,
      modificationTimeOptions,

      tableData,
      ...toRefs(pageData),
      selected,
      keepSelected,
      disableOperate,
      loading,
      loadingOnHeader,
      showDialog,
      showCreateCollaborationGuide,
      showInviteMemberGuide,
      importLoading,

      ...methods,
      ...listMethods,
      importPath,
      justShowImportPath,
      conditionParams,
      manual,
      isTemporary,
    };
  },
});
